var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageMain',{ref:"main",attrs:{"loading":_vm.loading,"tableData":_vm.tableData},on:{"reload":function($event){return _vm.getData()}}})}
var staticRenderFns = []

export { render, staticRenderFns }